export enum TEMPLATES {
	TEMPLATES_LOAD_START = 'TEMPLATES_LOAD_START',
	TEMPLATES_LOAD_DONE = 'TEMPLATES_LOAD_DONE',
	TEMPLATES_LOAD_FAIL = 'TEMPLATES_LOAD_FAIL'
}

export enum TEMPLATE {
	TEMPLATE_LOAD_START = 'TEMPLATE_LOAD_START',
	TEMPLATE_LOAD_DONE = 'TEMPLATE_LOAD_DONE',
	TEMPLATE_LOAD_FAIL = 'TEMPLATE_LOAD_FAIL'
}

export const TEMPLATE_EDIT_CHANGE = 'TEMPLATE_EDIT_CHANGE'
export const RESET_TEMPLATE_STORE = 'RESET_TEMPLATE_STORE'
